import "ant-design-vue/es/modal/style";
import _Modal from "ant-design-vue/es/modal";
import "ant-design-vue/es/popconfirm/style";
import _Popconfirm from "ant-design-vue/es/popconfirm";
import { __awaiter, __generator } from "tslib";
import { useService } from '@kaokei/use-vue-service';
import { defineComponent, createVNode, computed, onUnmounted, reactive, nextTick, watch } from 'vue';
import { ExamService } from '@/services/exam/exam.service';
import HeaderTip from './HeaderTip.vue';
import Countdown from './Countdown.vue';
import WorkProfileDialog from './WorkProfileDialog.vue';
import { CountdownService } from '@/services/exam/countdown.service';
import { useRouter, useRoute } from 'vue-router';
import { ExclamationCircleOutlined, LeftOutlined, SendOutlined, FileTextOutlined, QuestionCircleOutlined } from '@ant-design/icons-vue';
import { EnvCheckService } from '@/services/exam/envCheck.service';
import { QuestionService } from '@/services/exam/question.service';
import { RetainService } from '@/services/retain.service';
import { TOKEN_INVALID_ERRCODE, formatDateToSecond, getOtherLoginUrl } from '@/utils';
import { RecordVideoService } from '@/services/recordVideo/recordVideo.service';
import { ScreenMediaService } from '@/services/recordVideo/media.service';
import { ShowConfirmModal } from '../common/dialog';
export default defineComponent({
  name: 'UserExamHeader',
  components: {
    HeaderTip: HeaderTip,
    Countdown: Countdown,
    SendOutlined: SendOutlined,
    FileTextOutlined: FileTextOutlined,
    LeftOutlined: LeftOutlined,
    QuestionCircleOutlined: QuestionCircleOutlined,
    WorkProfileDialog: WorkProfileDialog,
    APopconfirm: _Popconfirm
  },
  setup: function () {
    var _this = this;
    var router = useRouter();
    var route = useRoute();
    var examService = useService(ExamService);
    var questionService = useService(QuestionService);
    var countdownService = useService(CountdownService);
    var envCheckService = useService(EnvCheckService);
    var retainService = useService(RetainService);
    var recordVideoService = useService(RecordVideoService);
    var screenMediaService = useService(ScreenMediaService);
    function jsonToQueryString(json) {
      if (!json) return;
      if (typeof json === 'object') {
        return Object.keys(json).map(function (key) {
          return encodeURIComponent(key) + '=' + encodeURIComponent(json[key]);
        }).join('&');
      }
    }
    var goBack = function (withUrlJump) {
      var _a, _b, _c;
      if (withUrlJump === void 0) {
        withUrlJump = false;
      }
      var otherLoginUrl = getOtherLoginUrl() || '';
      if (otherLoginUrl) {
        window.location.replace(otherLoginUrl);
        return;
      }
      var newQuery = ((_a = route.meta) === null || _a === void 0 ? void 0 : _a.ignoreQuery) ? undefined : route.query;
      if (withUrlJump) {
        var platform = Array.isArray(route.query.platform) ? route.query.platform[0] : route.query.platform || '';
        var contestMainListPath = platform ? (_c = (_b = route.meta) === null || _b === void 0 ? void 0 : _b.contestListPath) === null || _c === void 0 ? void 0 : _c[platform] : null;
        if (contestMainListPath) {
          window.location.replace(contestMainListPath);
          return;
        }
        window.location.replace("\n        /user".concat(newQuery ? '?' : '').concat(jsonToQueryString(newQuery)));
      } else {
        router.replace({
          name: 'UserItemList',
          query: newQuery
        });
      }
    };
    // 返回试卷，隐藏ide
    // 需要判断是否是自由创作题，需要提示用户填写作品简介
    var onHideIde = function () {
      if (!questionService.ideIframeDom || examService.answerMode) {
        // 当iframe还没有加载完成时，直接返回到答题卡页面
        questionService.showIde = false;
        return;
      }
      if (questionService.isProgramCreation) {
        var userAnswer = examService.getUserAnswerByQuestionId(questionService.question.id);
        if (!((userAnswer === null || userAnswer === void 0 ? void 0 : userAnswer.creationTitle) && (userAnswer === null || userAnswer === void 0 ? void 0 : userAnswer.creationSummary))) {
          return questionService.showWorkProfileDialog();
        }
      }
      questionService.hideIdeEvent();
    };
    var uploadSentryLog = function (api, res) {
      // eslint-disable-next-line
      console.log('setTag', 'api', api);
    };
    var onManualSubmitExam = function () {
      _Modal.confirm({
        title: '是否确认提交本次答题记录？',
        icon: createVNode(ExclamationCircleOutlined),
        content: '交卷后将不能再次做题，确认交卷吗？',
        okText: '确认',
        cancelText: '取消',
        class: 'exam-submit-confirm-modal',
        onOk: function () {
          examService.submitExam().then(function (res) {
            if (res && (res.errCode === 0 || res.errCode === 5010)) {
              examService.destroy();
              // 需要考虑自动交卷的时候 是否需要该逻辑 自动交卷的时候 考试时间已经到了 就不会出先录制入口了
              // 这里获取考试按钮的规则
              examService.getRecordButtonRule().then(function (res) {
                var _a, _b, _c, _d;
                if (res.introductionVideo === 1) {
                  try {
                    window.hetaoTrack('element_show', {
                      elementName: '提示录制弹窗',
                      pageName: '赛考页面',
                      uniqueId: (_a = examService.userExamId) !== null && _a !== void 0 ? _a : -1,
                      userId: ((_c = (_b = questionService.userService) === null || _b === void 0 ? void 0 : _b.user) === null || _c === void 0 ? void 0 : _c.userId) || 0,
                      examId: ((_d = examService.exam) === null || _d === void 0 ? void 0 : _d.examId) || 0
                    });
                    // eslint-disable-next-line
                  } catch (e) {}
                  ShowConfirmModal({
                    title: '交卷成功',
                    content: '本次比赛需要录制讲解视频，请交卷并录制',
                    okText: '马上录制',
                    cancelText: '稍后录制',
                    okLoading: false
                  }).then(function () {
                    var _a, _b, _c, _d;
                    try {
                      window.hetaoTrack('element_click', {
                        elementName: '马上录制',
                        pageName: '赛考页面',
                        uniqueId: (_a = examService.userExamId) !== null && _a !== void 0 ? _a : -1,
                        userId: ((_c = (_b = questionService.userService) === null || _b === void 0 ? void 0 : _b.user) === null || _c === void 0 ? void 0 : _c.userId) || 0,
                        examId: ((_d = examService.exam) === null || _d === void 0 ? void 0 : _d.examId) || 0
                      });
                      // eslint-disable-next-line
                    } catch (e) {}
                    retainService.dispose();
                    setTimeout(function () {
                      window.location.replace("/userexam/".concat(examService.userExamId, "/").concat(examService.answerPaperId, "/recorder?withCheck=checked"));
                    }, 120);
                  }).catch(function () {
                    var _a, _b, _c, _d;
                    try {
                      window.hetaoTrack('element_click', {
                        elementName: '稍后录制',
                        pageName: '赛考页面',
                        uniqueId: (_a = examService.userExamId) !== null && _a !== void 0 ? _a : -1,
                        userId: ((_c = (_b = questionService.userService) === null || _b === void 0 ? void 0 : _b.user) === null || _c === void 0 ? void 0 : _c.userId) || 0,
                        examId: ((_d = examService.exam) === null || _d === void 0 ? void 0 : _d.examId) || 0
                      });
                      // eslint-disable-next-line
                    } catch (e) {}
                    retainService.dispose();
                    goBack(true);
                  });
                } else {
                  _Modal.success({
                    title: '交卷成功',
                    content: '交卷成功',
                    onOk: function () {
                      retainService.dispose();
                      goBack(true);
                    }
                  });
                }
              }).catch(function () {
                _Modal.success({
                  title: '交卷成功',
                  content: '交卷成功',
                  onOk: function () {
                    retainService.dispose();
                    goBack(true);
                  }
                });
              });
            } else if (!(res && res.errCode === TOKEN_INVALID_ERRCODE)) {
              // 这里需要排除掉交卷的时候用户已经登出系统
              _Modal.error({
                title: '交卷失败',
                content: '交卷失败，请稍后再试'
              });
              uploadSentryLog('onManualSubmitExam', res);
            }
          });
        }
      });
    };
    var onAutoSubmitExam = function () {
      return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              if (!questionService.showIde) return [3 /*break*/, 2];
              return [4 /*yield*/, questionService.trySaveIde()];
            case 1:
              _a.sent();
              _a.label = 2;
            case 2:
              examService.submitExam().then(function (res) {
                if (res && (res.errCode === 0 || res.errCode === 5010)) {
                  examService.destroy();
                  // 顺便销毁手动交卷的弹窗
                  _Modal.destroyAll();
                  _Modal.success({
                    title: '考试结束',
                    content: '考试已结束，系统将自动保存答题记录并交卷',
                    onOk: function () {
                      retainService.dispose();
                      goBack(true);
                    }
                  });
                } else if (!(res && res.errCode === TOKEN_INVALID_ERRCODE)) {
                  // 这里需要排除掉交卷的时候用户已经登出系统
                  _Modal.error({
                    title: '考试结束',
                    content: '考试已结束，自动交卷失败，请手动交卷'
                  });
                  uploadSentryLog('onAutoSubmitExam', res);
                }
              });
              return [2 /*return*/];
          }
        });
      });
    };
    var tip = computed(function () {
      if (envCheckService.isBrowserNotValid) {
        return 1;
      } else if (envCheckService.isVideoNotAllowed) {
        return 2;
      } else if (envCheckService.isVideoError) {
        return 3;
      } else {
        return 0;
      }
    });
    if (!examService.answerMode) {
      countdownService.registerCallback(onAutoSubmitExam);
      countdownService.startCountdown().then(function () {
        if (countdownService.remainTime <= 0) {
          // 正常不会进入这个逻辑
          // 因为如果是已交卷，则startExam接口会报错
          onAutoSubmitExam();
        }
      });
    }
    // 利用firstTimeShowIde的展示隐藏 处理重新加载iframe
    var IframeConf = reactive({
      timer: undefined,
      disabled: false
    });
    var reloadIframe = function () {
      clearTimeout(IframeConf.timer);
      questionService.ideIframeSaving = false;
      // 该操作可能导致ide代码丢失 请谨慎使用
      IframeConf.timer = setTimeout(function () {
        var _a, _b;
        questionService.iframeRefreshTag = Date.now();
        window.hetaoTrack('element_click', {
          elementName: '重载项目-确定',
          pageName: '赛考页面',
          url: location.href,
          id: questionService.question.id,
          userId: ((_b = (_a = questionService.userService) === null || _a === void 0 ? void 0 : _a.user) === null || _b === void 0 ? void 0 : _b.userId) || 0
        });
      }, 80);
    };
    var reloadIframeClick = function () {
      var _a, _b;
      window.hetaoTrack('element_click', {
        elementName: '重载项目-入口',
        pageName: '赛考页面',
        url: location.href,
        id: questionService.question.id,
        userId: ((_b = (_a = questionService.userService) === null || _a === void 0 ? void 0 : _a.user) === null || _b === void 0 ? void 0 : _b.userId) || 0
      });
    };
    var onRecordBtnAction = function () {
      var _a, _b, _c, _d;
      screenMediaService.videoPreviewConfig.urlPreview = false;
      recordVideoService.reGetRecordLogic();
      try {
        window.hetaoTrack('element_click', {
          elementName: '录制讲解视频',
          pageName: '赛事录屏页面',
          uniqueId: (_a = examService.userExamId) !== null && _a !== void 0 ? _a : -1,
          userId: ((_c = (_b = questionService.userService) === null || _b === void 0 ? void 0 : _b.user) === null || _c === void 0 ? void 0 : _c.userId) || 0,
          examId: ((_d = examService.exam) === null || _d === void 0 ? void 0 : _d.examId) || 0
        });
        // eslint-disable-next-line
      } catch (e) {}
    };
    // 预览视频
    var onShowIntroVideo = function () {
      var _a, _b, _c, _d;
      recordVideoService.hideRecordCom();
      examService.getRecordVideoUrl().then(function (res) {
        screenMediaService.blobData = null;
        screenMediaService.blobUrl = res.videoUrl;
        screenMediaService.videoPreviewConfig.urlPreview = true;
        screenMediaService.showVideoPreview(true);
      });
      try {
        window.hetaoTrack('element_click', {
          elementName: '查看讲解视频',
          pageName: '赛事录屏页面',
          uniqueId: (_a = examService.userExamId) !== null && _a !== void 0 ? _a : -1,
          userId: ((_c = (_b = questionService.userService) === null || _b === void 0 ? void 0 : _b.user) === null || _c === void 0 ? void 0 : _c.userId) || 0,
          examId: ((_d = examService.exam) === null || _d === void 0 ? void 0 : _d.examId) || 0
        });
        // eslint-disable-next-line
      } catch (e) {}
    };
    var showVideoUpload = function () {
      var _a, _b, _c, _d;
      recordVideoService.showVideoUpload();
      try {
        window.hetaoTrack('element_click', {
          elementName: '上传讲解视频',
          pageName: '赛事录屏页面',
          uniqueId: (_a = examService.userExamId) !== null && _a !== void 0 ? _a : -1,
          userId: ((_c = (_b = questionService.userService) === null || _b === void 0 ? void 0 : _b.user) === null || _c === void 0 ? void 0 : _c.userId) || 0,
          examId: ((_d = examService.exam) === null || _d === void 0 ? void 0 : _d.examId) || 0
        });
        // eslint-disable-next-line
      } catch (e) {}
    };
    var showRecordActionArea = computed(function () {
      return examService.answerMode && !questionService.showIde && !recordVideoService.checkRecordSuccess && recordVideoService.showRecordScreenCom;
    });
    // examService.introductionVideoButtonList 枚举值含义
    // UPLOAD_VIDEO(1,"上传讲解视频"),
    // RECORD_VIDEO(2,"录制讲解视频"),
    // UPDATE_VIDEO(3,"变更讲解视频"),
    // VIEW_VIDEO(4,"查看讲解视频")
    var showCustomUploadEntrance = computed(function () {
      return showRecordActionArea.value && examService.introductionVideoButtonList.includes(1);
    });
    var showRecordActionData = computed(function () {
      // 展示录制按钮类型 0 默认值 可做不展示用 1 标识录制 2 标识查看
      var showBtnType = 0;
      var showRecordTxt = '';
      if (examService.introductionVideoButtonList.includes(2)) {
        showBtnType = 1;
        showRecordTxt = '录制讲解视频';
      }
      if (examService.introductionVideoButtonList.includes(3)) {
        showBtnType = 1;
        showRecordTxt = '变更讲解视频';
      }
      return {
        showBtnType: showBtnType,
        showRecordTxt: showRecordTxt
      };
    });
    var showUploadIntroVideoBtn = computed(function () {
      return examService.introductionVideoButtonList.includes(4);
    });
    onUnmounted(function () {
      clearTimeout(IframeConf.timer);
      nextTick(function () {
        _Modal.destroyAll();
      });
    });
    watch(function () {
      return showCustomUploadEntrance;
    }, function () {
      if (showCustomUploadEntrance.value) {
        nextTick(function () {
          var _a, _b, _c, _d;
          try {
            window.hetaoTrack('element_show', {
              elementName: '上传讲解视频',
              pageName: '赛事录屏页面',
              uniqueId: (_a = examService.userExamId) !== null && _a !== void 0 ? _a : -1,
              userId: ((_c = (_b = questionService.userService) === null || _b === void 0 ? void 0 : _b.user) === null || _c === void 0 ? void 0 : _c.userId) || 0,
              examId: ((_d = examService.exam) === null || _d === void 0 ? void 0 : _d.examId) || 0
            });
            // eslint-disable-next-line
          } catch (e) {}
        });
      }
    }, {
      immediate: true
    });
    watch(function () {
      return showRecordActionData;
    }, function () {
      if (showRecordActionData.value.showBtnType) {
        nextTick(function () {
          var _a, _b, _c, _d;
          try {
            window.hetaoTrack('element_show', {
              elementName: showRecordActionData.value.showRecordTxt,
              pageName: '赛事录屏页面',
              uniqueId: (_a = examService.userExamId) !== null && _a !== void 0 ? _a : -1,
              userId: ((_c = (_b = questionService.userService) === null || _b === void 0 ? void 0 : _b.user) === null || _c === void 0 ? void 0 : _c.userId) || 0,
              examId: ((_d = examService.exam) === null || _d === void 0 ? void 0 : _d.examId) || 0
            });
            // eslint-disable-next-line
          } catch (e) {}
        });
      }
    }, {
      immediate: true
    });
    watch(function () {
      return showUploadIntroVideoBtn;
    }, function () {
      if (showUploadIntroVideoBtn.value) {
        nextTick(function () {
          var _a, _b, _c, _d;
          try {
            window.hetaoTrack('element_show', {
              elementName: '查看讲解视频',
              pageName: '赛事录屏页面',
              uniqueId: (_a = examService.userExamId) !== null && _a !== void 0 ? _a : -1,
              userId: ((_c = (_b = questionService.userService) === null || _b === void 0 ? void 0 : _b.user) === null || _c === void 0 ? void 0 : _c.userId) || 0,
              examId: ((_d = examService.exam) === null || _d === void 0 ? void 0 : _d.examId) || 0
            });
            // eslint-disable-next-line
          } catch (e) {}
        });
      }
    }, {
      immediate: true
    });
    return {
      examService: examService,
      questionService: questionService,
      countdownService: countdownService,
      onManualSubmitExam: onManualSubmitExam,
      onAutoSubmitExam: onAutoSubmitExam,
      tip: tip,
      onHideIde: onHideIde,
      formatDateToSecond: formatDateToSecond,
      IframeConf: IframeConf,
      reloadIframe: reloadIframe,
      reloadIframeClick: reloadIframeClick,
      onRecordBtnAction: onRecordBtnAction,
      showVideoUpload: showVideoUpload,
      showRecordActionArea: showRecordActionArea,
      showCustomUploadEntrance: showCustomUploadEntrance,
      showRecordActionData: showRecordActionData,
      showUploadIntroVideoBtn: showUploadIntroVideoBtn,
      onShowIntroVideo: onShowIntroVideo
    };
  }
});